import Contact from './Contact.jsx';
import ContactForm from './ContactForm.jsx';

export {
  Contact,
  ContactForm
}


// WEBPACK FOOTER //
// ./components/contact/index.js